var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 19.5453C13.0039 19.5453 13.818 18.7312 13.818 17.7271C13.818 16.723 13.0039 15.9089 11.9998 15.9089C10.9957 15.9089 10.1816 16.723 10.1816 17.7271C10.1816 18.7312 10.9957 19.5453 11.9998 19.5453Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1814 12.5454C15.8178 11.2726 13.9996 10.4545 11.9996 10.4545C9.99965 10.4545 8.18149 11.2726 6.81787 12.5454",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 8.72723C18.7271 6.45453 15.5453 5 11.9999 5C8.45449 5 5.2727 6.45453 3 8.72723",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallConnection);
export default __webpack_public_path__ + "static/media/small-connection.1087302f.svg";
export { ForwardRef as ReactComponent };